export const dataErrorMessage = (
    <p>
        Could not load data, please try again in 5 minutes or contact{" "}
        <a href="mailto:admin@safe2drive.co.uk">
            <b>admin@safe2drive.co.uk</b>
        </a>
    </p>
);
